import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { Navbar } from '../Navbar';
import { useNotificationPreferences } from '@practium/features/profile';
import styles from './AppLayout.module.css';
import type { NavbarConfig } from '../Navbar/types/navbar.types';
import type { SidebarConfig } from '../Sidebar/types/sidebar.types';

export interface AppLayoutProps {
	sidebarConfig: SidebarConfig;
	navbarConfig: NavbarConfig;
	isSidebarOpen: boolean;
	onMenuClick: () => void;
	onCloseSidebar: () => void;
	topBanner?: ReactNode;
}

export const AppLayout = ({
	sidebarConfig,
	navbarConfig,
	isSidebarOpen,
	onMenuClick,
	onCloseSidebar,
	topBanner,
}: AppLayoutProps) => {
	const { notificationsEnabled } = useNotificationPreferences();

	return (
		<div className={styles.root}>
			{topBanner}
			<div className={styles.appLayout}>
				<Sidebar config={sidebarConfig} isOpen={isSidebarOpen} onClose={onCloseSidebar} />
				<div className={styles.mainContainer}>
					<Navbar
						config={navbarConfig}
						onMenuClick={onMenuClick}
						notificationsEnabled={notificationsEnabled}
					/>
					<main className={styles.content}>
						<div className={styles.contentInner}>
							<Outlet />
						</div>
					</main>
				</div>
			</div>
		</div>
	);
};
